import React from "react";
import { Button, Grid, TextField, Typography } from "@mui/material";
import { observer } from "mobx-react";

interface RequestResetEmailFormProps {
  userEmail: string;
  mailSent: boolean;
  isOtpVerified: boolean;
  isResetPasswordPage: boolean;
  handleSendOTP: (e: React.MouseEvent<HTMLButtonElement>) => void;
  setEmail: (email: string) => void;
}

export const RequestResetEmailForm = observer(({
  userEmail,
  mailSent,
  isOtpVerified,
  isResetPasswordPage,
  handleSendOTP,
  setEmail
}: RequestResetEmailFormProps) => {
  return (
    <>
      {(mailSent || !isOtpVerified) && (
        <>
          <Typography variant="h6" gutterBottom align="center">
            Passwort zurücksetzen
          </Typography>

          <Grid container justifyContent="center" sx={{ mb: 2 }}>
            <Grid item xs={12} md={isResetPasswordPage ? 6 : 9} lg={isResetPasswordPage ? 4 : 9}>
              <TextField
                label="Benutzernamen/E-Mail-Adresse"
                type="email"
                fullWidth
                value={userEmail}
                onChange={(e) => setEmail(e.target.value)}
              />
            </Grid>
          </Grid>

          <Grid container justifyContent="center" sx={{ mb: 2 }}>
            <Grid item xs={12} md={6} lg={2}>
              <Button
                variant="contained"
                color="primary"
                onClick={handleSendOTP}
                disabled={!userEmail}
                fullWidth
              >
                Reset
              </Button>
            </Grid>
          </Grid>

          {!isOtpVerified && isResetPasswordPage && (
            <Grid container justifyContent="center">
              <Grid item xs={12} md={8}>
                <Typography
                  variant="body2"
                  color="error"
                  align="center"
                  sx={{ mt: 2, fontSize: 18 }}
                >
                  The user is unauthorised and must enter their email address to reset their password.
                </Typography>
              </Grid>
            </Grid>
          )}
        </>
      )}

      {mailSent && !isOtpVerified && (
        <>
          <Typography variant="h6" gutterBottom align="center">
            E-Mail-Verifizierung
          </Typography>
          <Typography variant="body2" gutterBottom align="center">
            Bitte überprüfen Sie Ihren Posteingang. Wir haben eine Nachricht an die folgende
            E-Mail-Adresse gesendet: {userEmail}
          </Typography>

          <Typography
            variant="body1"
            color="primary"
            onClick={handleSendOTP}
            style={{
              cursor: "pointer",
              textAlign: "center",
              textDecoration: "underline",
              marginTop: "1rem",
            }}
          >
            Sie haben keine E-Mail erhalten? Erneut senden
          </Typography>
        </>
      )}
    </>
  );
});
